import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { Total } from 'core/elements';
import { NumberHelper } from 'core/helpers';

interface IProps {
  entityType: string;
  count: number;
  filteredCount: number;
  classNames?: string;
  showFiltered?: boolean;
}

export const TotalAndFilterCount = ({
  entityType,
  count,
  filteredCount,
  classNames = '',
  showFiltered = false,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Total
        label={t(`labelTotal${entityType}s`)}
        value={NumberHelper.formatInteger({ amount: count })}
        options={{ classNames }}
      />
      {showFiltered && (
        <Total
          label={t('labelFiltered')}
          value={NumberHelper.formatInteger({ amount: filteredCount })}
          options={{ classNames }}
        />
      )}
    </Box>
  );
};
